export const selectBalance = {
	data: (state) => state.wallet.balance.data,
	fetch: (state) => state.wallet.balance.fetch,
	withdraw_status: (state) => state.wallet.balance.withdraw_status,
};
